import { ChevronRight, CalendarDays } from "lucide-react";
import { cedi2 as cedi } from "@/lib/api";

export const ledgerEvents = (events, summary) => {
  const blank = { count: 0, collected: 0, outstanding: 0, overpayment: 0, fully_paid: 0, with_balance: 0 };
  const map = new Map(events.map((e) => [e.id, { id: e.id, title: e.title, date: e.date || e.start_date || "", ...blank }]));
  summary.forEach((s) => {
    const base = map.get(s.event_id) || { id: s.event_id, title: s.title, date: "", deleted: s.deleted, archived: s.archived };
    map.set(s.event_id, { ...base, ...s, title: base.title || s.title });
  });
  return [...map.values()];
};

const EventCard = ({ ev, onOpen }) => (
  <button onClick={() => onOpen(ev)} className="w-full text-left bg-white border border-[#E5E7EB] rounded-lg p-4 flex items-center gap-4 hover:border-[#E60000] hover:shadow-sm transition-[border-color,box-shadow]" data-testid={`ledger-event-${ev.id}`}>
    <div className="w-10 h-10 rounded-md bg-[#FFF0F0] text-[#E60000] grid place-items-center shrink-0"><CalendarDays className="w-5 h-5" /></div>
    <div className="flex-1 min-w-0">
      <div className="font-heading font-bold truncate">{ev.title}{ev.deleted && <span className="ml-2 text-[10px] font-bold uppercase tracking-wider bg-red-50 text-red-800 rounded px-1.5 py-0.5">Deleted</span>}{ev.archived && <span className="ml-2 text-[10px] font-bold uppercase tracking-wider bg-slate-200 text-slate-700 rounded px-1.5 py-0.5">Archived</span>}</div>
      <div className="text-xs text-gray-500">{ev.date && `${ev.date} · `}{ev.count} registration(s)</div>
    </div>
    <div className="hidden sm:block text-right text-xs">
      <div className="font-mono font-semibold" data-testid={`ledger-event-collected-${ev.id}`}>{cedi(ev.collected)} collected</div>
      <div className="text-gray-500" data-testid={`ledger-event-outstanding-${ev.id}`}>{cedi(ev.outstanding)} outstanding</div>
    </div>
    <ChevronRight className="w-4 h-4 text-gray-400" />
  </button>
);

export const LedgerEvents = ({ list, onOpen }) => (
  <div className="space-y-3" data-testid="ledger-event-list">
    {list.map((ev) => <EventCard key={ev.id} ev={ev} onOpen={onOpen} />)}
    {!list.length && <div className="p-10 text-center text-sm text-gray-500 bg-white border rounded-lg" data-testid="ledger-no-events">No events found.</div>}
  </div>
);
